import { render, staticRenderFns } from "./FPagination.vue?vue&type=template&id=838dea6a&"
import script from "./FPagination.vue?vue&type=script&lang=js&"
export * from "./FPagination.vue?vue&type=script&lang=js&"
import style0 from "./FPagination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports